export const ITEM_BOX_MARGIN = '1%';
export const ITEM_BOX_MARGIN_NUMBER = 1;
